import candidateApi from '~/clientApis/candidateApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { COPY_FAIL_MESSAGE } from '~/consts/candidates';
import { CopyCandidateRequest } from '~/definitions/candidates';
import { getStore } from '~/mobx/AppStore';

const copyCandidate = async () => {
    const { candidateStore } = getStore();

    candidateStore.setCopyingCandidate(true);

    try {
        const requestParams: CopyCandidateRequest = {
            candidate_id: candidateStore.selectedCandidateId,
            region_id: candidateStore.selectedRegionIdForCopy,
        };

        await candidateApi.copyCandidate(requestParams);
        candidateStore.setIsCopyingCandidateSuccess(true);
    } catch (error) {
        showMessageModal('error', COPY_FAIL_MESSAGE);

        candidateStore.setIsCopyingCandidateSuccess(false);
    } finally {
        candidateStore.setCopyingCandidate(false);
    }
};

export default copyCandidate;
